import { Component, OnInit, ChangeDetectorRef, ComponentFactoryResolver } from '@angular/core';
import { MachineLearningWizardComponent } from '../machine-learning-wizard.component';
import { MachineLearningResetWizardService } from '../../../services/machine.learning/machine-learning-reset-wizard.service';
import { ActivatedRoute } from '@angular/router';
import { ValuesExchangeProvider } from '@nrwl/common-lib';
import { MlSelectSiteComponent } from './ml-select-site/ml-select-site.component';

@Component({
  selector: 'ml-wizard-select-application',
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", "../machine-learning-wizard.style.scss", "../../../wizard.button.style.scss"]
})
export class MlSelectSiteWizardComponent extends MachineLearningWizardComponent {
  constructor(
    mlResetWizardService: MachineLearningResetWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider) {
      super(mlResetWizardService, changeDetectorRef, activatedRoute, factoryResolver);
  }

  resolveComponentType() {
      return MlSelectSiteComponent;
  }

  toggleFinish() {
    let kpiObject = this.wizardService.onApply();
    this.exchange.notifyListeners('ml_reset_option', kpiObject);
    this.toggleClose();
  }
}
